import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,_vm._b({staticClass:"vertical-nav-menu-link",attrs:{"active-class":"bg-gradient-primary white--text"}},'v-list-item',_vm.$attrs,false),[_c(VListItemIcon,[_c(VIcon,{staticClass:"mx-auto",class:{'alternate-icon-small': !_vm.icon}},[_vm._v(" "+_vm._s(_vm.icon || _vm.alternateIcon)+" ")])],1),_c(VListItemTitle,[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }